<template>
  <StudioAlertBanner type="info" data-testId="tracking-consent-notice">
    <p class="tw-font-semibold">Visitor tracking consent is on</p>
    <p v-if="showTagRule" class="tw-mt-1">
      Tracking tags in Head and Body need a category. Add
      <span class="tw-font-mono">data-consent-type="analytics"</span> or
      <span class="tw-font-mono">"marketing"</span> to each one — unclassified tags are flagged in the editor.
    </p>
    <p class="tw-mt-1">{{ scriptFieldsExplanation }}</p>
    <pre class="tw-mt-1 tw-overflow-x-auto tw-rounded tw-bg-white/60 tw-p-2 tw-font-mono tw-text-xs">{{ guard }}</pre>
    <p class="tw-mt-1">
      Use <span class="tw-font-mono">analytics</span> or <span class="tw-font-mono">marketing</span>, whichever the
      script belongs to.
    </p>
  </StudioAlertBanner>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { CONSENT_GUARD_SNIPPET } from './marketingTags.constants';

import StudioAlertBanner from '@/studioComponents/StudioAlertBanner.vue';

/** Explains per-tag consent classification once, above the code areas. */
export default defineComponent({
  name: 'TrackingConsentNotice',
  components: { StudioAlertBanner },
  props: {
    /** False on the splash snippet, which has no HTML code area. */
    showTagRule: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    guard(): string {
      return CONSENT_GUARD_SNIPPET;
    },
    scriptFieldsExplanation(): string {
      return this.showTagRule
        ? 'The function fields below carry no tag to classify, so they always run whatever the visitor chose. Guard tracking in them yourself:'
        : 'This script carries no tag to classify, so it always runs whatever the visitor chose. Guard tracking in it yourself:';
    }
  }
});
</script>
